



































































import { Paths } from '@/router';
import { WorkerService } from '@/services/WorkerService';
import { IWorksheet, WorksheetsService } from '@/services/WorksheetsService';
import { Mutations } from '@/store';
import BButton from 'buefy/src/components/button/Button.vue';
import BTableColumn from 'buefy/src/components/table/TableColumn.vue';
import { Component, Vue } from 'vue-property-decorator';
import * as FileSaver from 'file-saver';
import ConfirmationModal from '../ConfirmationModal.vue';

@Component({
  components: { BTableColumn, BButton },
})
export default class Worklogs extends Vue {
  private totalItems: number = 0;
  private worksheets: IWorksheet[] = [];
  private currentPageNumber: number = 1;

  private nrWorksheetsPerPage: number = 10;
  private loading: boolean = false;

  private newWorklog() {
    this.$router.push({ name: Paths.NEW_WORKLOG });
    return;
  }

  private async edit(id: number) {
    await this.$router.push({ name: Paths.EDIT_WORKLOG, params: { worklogId: id.toString() } });
    return;
  }

  private async onPageChange(page: number) {
      this.currentPageNumber = page;
      await this.refresh();
  }

  private async savePdf(id: number) {
      try {
        const blob = await WorksheetsService.downloadPdf(id);
        await FileSaver.saveAs(blob, `delovni_nalog_${id}.pdf`);
      } catch (err) {
        console.error('Error while saving PDF', err);
      }
  }

  private async refresh() {
    this.loading = true;

    const page = await WorksheetsService.getWorksheets(this.currentPageNumber, this.nrWorksheetsPerPage);
    this.worksheets = page.data;
    this.totalItems = page.totalItems;

    this.loading = false;
  }

  private async created() {
    this.loading = true;
    const worker = await WorkerService.getWorker();

    if (worker === null) {
      this.$router.push({ name: Paths.NEW_WORKER });
      return;
    }

    this.$store.commit(Mutations.SET_WORKER, worker);

    await this.refresh();
  }

  private async deleteWorksheet(id: number) {
      this.$modal.open({
          parent: this,
          component: ConfirmationModal,
          hasModalCard: true,
          canCancel: false,
          events: {
            confirmed: async () => {
              try {
                await WorksheetsService.deleteWorksheet(id);
                await this.refresh();
              } catch (err) {
                console.error('Error while deleting a worksheet!', err);
              }
            },
          },
      });
  }
}
